exports.categoryFilter = (value) => {
  if (value) {
    if (!value.unit && !value.smaller && !value.greater && !value.between && !value.like) {
      return value
        } else { 
        var unit = '';
        if (value.unit) {
          unit = value.unit
        }

        if (value.smaller) {
          return "小于" + value.smaller + unit
        }

        if (value.greater) {
          return "大于" + value.greater + unit
        }

        if (value.between) {
          return value.between.start + '-' + value.between.end + unit
        }

        if (value.like) {
          return value.like + unit
        }
        }

      }
  };
exports.moneyFilter = (value) => {
  if (value) {
    var list = []
    list = value.split("-")
    var price = parseFloat(list[0]) + "-" + parseFloat(list[1])
    return price
  }
};
exports.giaFilter = (value) => { 
      var gia;
      if (value == "Y") {
        gia = "是";
        return gia;
      } else if (value == "N") {
        gia = "否";
        return gia;
      }
}